
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 80 80"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"18.34","height":"44.02","x":"6","y":"47.99","fill":"#BED0F5","rx":"9.17","transform":"rotate(-60 6 47.99)"}}),_c('rect',{attrs:{"width":"18.34","height":"58.69","x":"57.58","y":"10","fill":"#2964E1","rx":"9.17","transform":"rotate(30 57.58 10)"}})])
          )
        }
      }
    